import { useBetbook } from "~/store/betbook";
import formatNumber from "./formatNumber";

const formatOdds = (odds: number, numerator: number, denominator: number) => {
	const betbook = useBetbook();
	if (betbook.oddsFormat === "fractional" && numerator && denominator) {
		return numerator + "/" + denominator;
	}
	return formatNumber(odds, "odds");
};

export default formatOdds;
